// extracted by mini-css-extract-plugin
export var closeButton = "_lb-1";
export var closeX = "_lb-3";
export var container = "_lb-0";
export var image = "_lb-2";